/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_TitleInputs */



/**
* | output |
* | --- |
* | "Offline Activation" |
*
* @param {Offline_Activation_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_title = /** @type {((inputs?: Offline_Activation_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activation hors ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Offline-Aktivierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attivazione offline")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автономная активация")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activación sin conexión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("离线激活")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オフラインアクティベーション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑफ़लाइन सक्रियण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativação offline")
	return /** @type {LocalizedString} */ ("Offline Activation")
});